import {ConfirmationAction} from './confirmation-action.model';
import {ConfirmationAlertData} from './confirmation-alert-data.model';

export class ConfirmationData {
	titre: string;
	message: string;
	actions: ConfirmationAction[];
	translateParams: any;
	modaleStyleClass: string;
	closable: boolean = true;
	messageInformation: string;
	translateParamsMessageInformation: any;
	alertData?: ConfirmationAlertData;

	constructor(titre?: string, message?: string, actions?: ConfirmationAction[], translateParams?: any, modaleStyleClass?: string, closable?: boolean, messageInformation?: string,
				translateParamsMessageInformation?: any, alertData?: ConfirmationAlertData) {
		this.titre = titre;
		this.message = message;
		this.actions = actions;
		this.translateParams = translateParams;
		this.modaleStyleClass = modaleStyleClass;
		this.closable = closable ?? true;
		this.messageInformation = messageInformation;
		this.translateParamsMessageInformation = translateParamsMessageInformation;
		this.alertData = alertData;
	}
}
